<template lang="pug">
    v-container(wrap)
        v-layout
            formStepper(:model ='model', :field='field' :onSave='createPost' @onClose='$emit("close")' :context='currentContext')
</template>
<script>
  import Stepper from './Stepper.vue'
  let vm = null
  export default {
    components: {
      formStepper: Stepper,

    },
    props: {
      currentContext: String,
    },
    data: () => ({
      model: {
        username: null,
        title: null,
        content: null,
        image: null,
        audio: null,
        subject: null,

      },
    }),
    created () {
      vm = this
      // const database = firebase.database();
      // const storage = firebase.storage();
    },
    methods: {
      createPost: function () {
        // A post entry.
        const vm = this
        const itemData = {
          username: vm.model.username,
          uid: vm.model.uid,
          subject: vm.model.subject,
          title: vm.model.title,
          content: vm.model.content,
          image: vm.model.image,
          audio: vm.model.audio,
          icon: vm.icon,
        }
        vm.$store.commit('cms/setLoading', true)
        vm.$forceUpdate()
        setTimeout(function () {
          vm.$store.dispatch('cms/createItem', { context: vm.currentContext, data: itemData }).then(() => {
            vm.onSuccess()
          })
        }, 1000)
      },
      onSuccess () {
        // this.$router.push({ name: 'Posts' })
        this.$emit('close')
        this.model = {
          username: null,
          title: null,
          content: null,
          image: null,
          audio: null,
          subject: null,
        }
        this.$forceUpdate()
      },
      setImage (image) {
        vm.model.imagen = image
        // // console.log(vm.model.imagen);
      },
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .ql-video {
        max-width: 100%;

    }
    img{
        max-width: 100%;
        height:auto;
    }
</style>
